import { cloneDeep, map } from 'lodash';
import { hasWindow } from '../utils';

const eventTypes = {
  pageImpression: 'page-impression',
  buttonClick: 'button-click',
  toolStart: 'tool-start',
  toolSubmit: 'tool-submit'
};

const mapVehicleToAnalyticsData = (vehicle) => {
  return {
    reference: vehicle.reference,
    identification: vehicle.identification,
    make: vehicle.makeKey,
    model: vehicle.modelKey,
    modelFamily: vehicle.modelFamilyKey,
    bodyType: vehicle.bodyKey,
    labels: vehicle.labels,
    category: vehicle.categoryKey,
    fuel: vehicle.fuelKey,
    transmission: vehicle.gearboxKey,
    kw: vehicle.kw,
    hp: vehicle.hp,
    mileage: vehicle.mileage,
    firstRegistrationYear: vehicle.firstRegistrationYear,
    firstRegistrationMonth: vehicle.firstRegistrationMonth,
    price: vehicle.price,
    monthlyPrice: vehicle.monthlyPrice,
    monthlyPriceType: vehicle.monthlyPriceType,
    doors: vehicle.doors,
    seats: vehicle.seats,
    vat: vehicle.vat,
    equipments: map(vehicle.equipments, (eq) => eq.key),
    exteriorColor: vehicle.exteriorColorKey,
    interiorColor: vehicle.interiorColorKey,
    interiorUpholstery: vehicle.interiorUpholsteryKey,
    co2: vehicle.co2,
    euroNorm: vehicle.euroNorm,
    location: vehicle.dealer ? vehicle.dealer.name : ''
  };
};

const resolvePageInfo = (context, window) => {
  return {
    language: context ? context.culture : undefined,
    url: window.location.href,
    name: context?.page
  };
};

const analyticsInitialize = (settings) => {
  console.log('initialize analytics Autralis');
  // TagManager.initialize(tagManagerArgs);
};

const analyticsEventSubmit = (tracker, event) => {
  debugger;
  if (hasWindow() && tracker) {
    try {
      tracker.push(event);
    } catch (err) {
      console.log('Event did not track correctly, reason:', err);
    }
  }
};

const buttonCtaEventInitialize = (props, context) => {
  return {
    event: eventTypes.buttonClick,
    page: resolvePageInfo(context, window),
    info: {
      buttonType: 'button-cta',
      buttonCategory: props.buttonCategory ? props.buttonCategory : 'undefined-link',
      buttonName: props.name,
      buttonText: props.buttonText,
      buttonTarget: props.target,
      buttonActionUrl: props.url,
      buttonActionSearch: props.search
    }
  };
};

const toolStartEventInitialize = (type, data, context) => {
  const vehicle = data && data.vehicle ? mapVehicleToAnalyticsData(data.vehicle) : undefined;

  return {
    event: eventTypes.toolStart,
    page: resolvePageInfo(context, window),
    info: {
      toolType: 'request-form',
      // toolName: 'myway-test-drive',
      requestType: type,
      toolStep: data.toolStep ? data.toolStep : undefined,
      // toolStepOption: '',
      toolStepNumber: data.toolStepNumber ? data.toolStepNumber : undefined
      // leadID: '',
      //errorMessage: '',
      //errorType: ''
    },
    vehicle
  };
};

const toolSubmitEventInitialize = (type, data, context) => {
  const vehicle = data && data.vehicle ? mapVehicleToAnalyticsData(data.vehicle) : undefined;

  return {
    event: eventTypes.toolSubmit,
    page: resolvePageInfo(context, window),
    info: {
      toolType: 'request-form',
      // toolName: 'myway-test-drive',
      requestType: type,
      toolStep: data && data.toolStep ? data.toolStep : undefined,
      //toolStepOption: '',
      toolStepNumber: data && data.toolStepNumber ? data.toolStepNumber : undefined
      // leadID: '',
      //errorMessage: '',
      //errorType: ''
    },
    vehicle
  };
};

const pageImpressionEventInitialize = (page, data, context, session) => {
  let eventData = {};

  // Fix for backwords compatible
  let type = '';
  if (typeof page === 'string') {
    type = page;
  } else {
    type = page.type;
  }

  if (type === 'vehicle') eventData = { ...eventData, vehicle: mapVehicleToAnalyticsData(data) };

  return {
    event: eventTypes.pageImpression,
    page: resolvePageInfo(context, window),
    ...eventData
  };
};

export const initialize = () => {
  const tracker = hasWindow() ? window.dataLayer : undefined;
  const settings = {
    id: ''
  };

  return {
    name: 'GOOGLE_TAG_AUTRALIS',
    settings: settings,
    tracker: tracker,

    analyticsInitialize: (settings) => analyticsInitialize(settings),
    pageImpressionEventInitialize: (page, data, context, session) => pageImpressionEventInitialize(page, data, context, session),
    analyticsEventSubmit: (event) => analyticsEventSubmit(tracker, event),
    productDetailInitialize: (props, context) => {
      return { event: 'product-initialize' };
    },
    productClickInitialize: (props, context) => {
      return { event: 'product-click' };
    },
    buttonCtaEventInitialize: (props, context) => buttonCtaEventInitialize(props, context),
    toolStartEventInitialize: (type, data, context) => toolStartEventInitialize(type, data, context),
    toolSubmitEventInitialize: (type, data, context) => toolSubmitEventInitialize(type, data, context),
    toolCompleteEventInitialize: (type, data, context) => {
      return { event: 'tool-complete' };
    },
    toolErrorEventInitialize: (type, data, context) => {
      return { event: 'tool-error' };
    },
    searchQueryEventInitialize: (props) => {
      return { event: 'search-query' };
    },
    filterQueryEventInitialize: (props) => {
      return { event: 'search-query' };
    },
    searchResultclickEventInitialize: (props) => {
      return { event: 'search-resultclick' };
    },
    contentblockImpressionEventInitialize: (context) => {
      return { event: 'content-block-impression' };
    },
    notificationImpressionEventInitialize: (props) => {
      return { event: 'notification-impression' };
    },
    notificationClickEventInitialize: (props) => {
      return { event: 'notification-click' };
    }
  };
};
